module.exports = __webpack_public_path__ + "static/img/this is my schl.d91a626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/news/this is my schl.png
// module id = UpSz
// module chunks = 1